import React, { useState, useEffect } from 'react';
import { Button, Form, Select, DatePicker, notification } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import fileDownload from 'js-file-download';
import axios from '../../../helpers/Axios';

const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';
const BRAND = '#0f8269';

const statuses = [
  { value: 1, label: 'Pending' },
  { value: 3, label: 'Activated' },
  { value: 4, label: 'Verified' },
  { value: 5, label: 'On-Hold' },
  { value: 6, label: 'Archived' },
  { value: 7, label: 'Declined' },
];

const authHeaders = {
  headers: {
    'X-Gravitee-Api-Key': process.env.REACT_APP_GRAVITEE_API_KEY_AUTHENTICATION,
  },
};

const filingHeaders = {
  headers: {
    'X-Gravitee-Api-Key': process.env.REACT_APP_GRAVITEE_API_KEY_FILING,
  },
};

const SODOfficerReportCard = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [sodUsers, setSODUsers] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    axios.get('https://api.fortisph.space/gateway/authentication/users/roles/?roles=25',
      authHeaders,
    ).then((res) => setSODUsers(res.data));
  }, []);

  const disabledDate = (current) => current && current > dayjs().endOf('day');

  const handleGenerateReport = async (values) => {
    const [startDate, endDate] = dateRange;

    if (!startDate || !endDate) {
      notification.warning({ message: 'Please select a valid date range.' });
      return;
    }

    setLoadingReport(true);

    try {
      const response = await axios.get(
        'https://api.fortisph.space/gateway/filing/reports/sodTracker/',
        {
          params: {
            start: startDate.format('YYYY-MM-DD'),
            end: endDate.format('YYYY-MM-DD'),
            user: values.user_id || '',
            status: values.status || '',
            action: values.action || '',
          },
          responseType: 'blob',
          ...filingHeaders,
        }
      );

      fileDownload(
        response.data,
        `SOD_Report_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`
      );

      notification.success({ message: 'Report generated successfully!' });
      form.resetFields();
      setDateRange([null, null]);
    } catch (error) {
      notification.error({ message: 'Failed to generate report.' });
    } finally {
      setLoadingReport(false);
    }
  };

  return (
    <Form layout="vertical" form={form} onFinish={handleGenerateReport} size="small">

      <Form.Item
        name="range"
        label="Date Range"
        rules={[{ required: true, message: 'Please select a date range' }]}
        style={{ marginBottom: 10 }}
      >
        <RangePicker
          style={{ width: '100%', display: 'flex' }}
          onChange={(dates) => setDateRange(dates)}
          disabledDate={disabledDate}
          format={dateFormat}
        />
      </Form.Item>

      <Form.Item name="user_id" label="Receiving Officer" style={{ marginBottom: 10 }}>
        <Select
          placeholder="All officers"
          allowClear
          showSearch
          optionFilterProp="label"
          options={sodUsers.map((u) => ({ value: u.id, label: u.name }))}
        />
      </Form.Item>

      <Form.Item name="status" label="Company Status" style={{ marginBottom: 10 }}>
        <Select
          placeholder="All statuses"
          allowClear
          options={statuses}
        />
      </Form.Item>

      <Form.Item name="action" label="Action" style={{ marginBottom: 18 }}>
        <Select
          placeholder="All actions"
          allowClear
          options={statuses}
        />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        block
        loading={loadingReport}
        icon={<FileExcelOutlined />}
        style={{ background: BRAND, borderColor: BRAND, height: 36, fontWeight: 600 }}
      >
        Generate Report
      </Button>

    </Form>
  );
};

export default SODOfficerReportCard;
